import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { defaultAvatar } from '../../../img/images';
import { RootState } from '../../../store';
import { getProfileImage } from '../../../store';

import './SusyAvatar.css';

export enum SuSyAvatarSizes {
    XS = 'xs', // 20px
    SM = 'sm', // 24px -> default
    MD = 'md', // 36px
    LG = 'lg', // 64px
    XL = 'xl', // 80px
}

interface ISusyAvatarProps {
    profilePictureId: string | undefined;
    withOutline?: boolean;
    size?: SuSyAvatarSizes;
    className?: string;
}

const SusyAvatar = (props: ISusyAvatarProps) => {
    const images = useSelector((state: RootState) => state.images);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!props.profilePictureId) {
            return;
        }

        dispatch(getProfileImage(props.profilePictureId));
    }, [props.profilePictureId]);

    const getImageSize = () => {
        if (!props.size) {
            return '24px';
        }

        switch (props.size) {
            case SuSyAvatarSizes.XS:
                return '20px';
            case SuSyAvatarSizes.SM:
                return '24px';
            case SuSyAvatarSizes.MD:
                return '36px';
            case SuSyAvatarSizes.LG:
                return '64px';
            case SuSyAvatarSizes.XL:
                return '80px';
        }
    };

    const imageSrc = props.profilePictureId
        ? images[props.profilePictureId]
        : defaultAvatar;

    return (
        <div className={props.withOutline ? 'green-outline' : undefined}>
            <img
                data-testid={'profile-picture-image'}
                src={imageSrc}
                className={`profile-picture-image ${props.className}`}
                style={{
                    width: getImageSize(),
                    height: getImageSize(),
                }}
                alt=''
            />
        </div>
    );
};

export default SusyAvatar;
